import { Link } from "react-router-dom";

export default function CtaBanner() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6">
      <div className="relative overflow-hidden rounded-lg">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20abstract%20anime%20energy%20collage%20with%20colorful%20paper%20streamers%20and%20ink%20splashes%2C%20warm%20orange%20red%20and%20gold%20tones%2C%20celebration%20and%20excitement%2C%20stylized%20editorial%20artwork%2C%20dynamic%20composition&width=1600&height=620&seq=cta-banner&orientation=landscape"
          alt="加入日漫追更社区"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 to-primary-700/60" />
        <div className="relative z-10 flex flex-col items-start gap-6 p-8 md:flex-row md:items-center md:justify-between md:p-12">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl text-white md:text-4xl">加入追更大军，不再错过任何一话</h2>
            <p className="mt-3 text-sm leading-relaxed text-white/85 md:text-base">
              从最新话、连载进度到情报剧透与休刊提醒，一站掌握全部日漫更新动态，与百万漫友同步追更。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/category/latest"
              className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-full bg-accent-500 px-7 py-3.5 text-base font-semibold text-white transition-transform hover:scale-105"
            >
              <i className="ri-flashlight-fill" /> 开始追更
            </Link>
            <Link
              to="/about"
              className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-full border border-white/40 bg-white/10 px-7 py-3.5 text-base font-medium text-white backdrop-blur-sm transition-colors hover:bg-white/20"
            >
              了解我们
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}